import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FunctionComponent, ReactNode } from "react";
import colors from "src/utils/colors";

interface Props {
  className?: string;
  isActive?: boolean;
  onClick?: (e: any) => void;
  children: ReactNode;
}

const ItemIconButton: FunctionComponent<Props> = (props) => {
  return (
    <button className={props.className} onClick={props.onClick} type="button">
      {props.children}
    </button>
  );
};

export default styled(ItemIconButton)`
  float: right;
  color: #999;
  width: 44px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
  transition: all 0.25s;
  border: none;
  background: none;
  outline: none;
  padding: 0;
  display: inline-block;
  /* clear: right; */
  &:hover {
    color: ${colors.dark};
  }
  &:active {
    color: #999;
  }
  ${(props: Props) =>
    props.isActive &&
    css`
      color: ${colors.action} !important;
    `};
`;
